import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const MRDetailsWebPageRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id`,
    component: lazyRouteComponent(() => import('./MRDetailsWebPage'))
  })
